document.addEventListener('DOMContentLoaded', function() {
  setTimeout(function() {
    const originalSwiperSlides = document.querySelectorAll('.media_match');

    function filterSlidesBySKU(sku) {
      const swiperContainers = document.querySelectorAll('.media_containers');
      let firstMatchedImageSrc = '';
      let firstImageSrc = '';

      swiperContainers.forEach(swiperContainer => {
        const swiperSlides = swiperContainer.querySelectorAll('.media_match');
        let matchCount = 0;

        swiperSlides.forEach((slide, index) => {
          const altText = slide.getAttribute('data-alt-text');
          if (index === 0) {
            firstImageSrc = slide.querySelector('img').src; // Save the first image src
          }
          if (altText === sku || altText.includes('blank')) {
            slide.style.display = 'block';
            if (altText === sku) {
              matchCount++;
              if (!firstMatchedImageSrc) {
                firstMatchedImageSrc = slide.querySelector('img').src; // Save the first matched image src
              }
            }
          } else {
            slide.style.display = 'none';
          }
        });

        // If no matching slides, show all slides
        if (matchCount < 1) {
          swiperSlides.forEach(slide => {
            slide.style.display = 'block';
          });
        }
      });

      // Update the main image with the first matched image or the first image if no match found
      if (firstMatchedImageSrc) {
        updateMainImage(firstMatchedImageSrc);
      } else if (firstImageSrc) {
        updateMainImage(firstImageSrc);
      }
    }

    function updateMainImage(imgSrc) {
      const mainImages = document.querySelectorAll('#mainImage img');
      mainImages.forEach(image => {
        image.src = imgSrc;
      });
    }

    document.querySelectorAll('.swatch-items-wrapper').forEach(items => {
      items.addEventListener('change', function(e) {
        const label = e.target.closest('input');
        if (label) {
          var ThisSKUWrapper = label.closest('.product-details-wrapper');
          var ThisSKUSelectBox = ThisSKUWrapper ? ThisSKUWrapper.querySelector('.product-single__variants') : null;
          var SelectedOption = ThisSKUSelectBox ? ThisSKUSelectBox.querySelector('option:checked') : null;
          if (SelectedOption) {
            setTimeout(function() {
              const sku = SelectedOption.getAttribute('sku');
              filterSlidesBySKU(sku);
            }, 100);
          }
        }
      });
    });

    document.querySelectorAll('.media_containers .media_match').forEach(thumbnail => {
      thumbnail.addEventListener('click', () => {
        const imgSrc = thumbnail.querySelector('img').src;
        updateMainImage(imgSrc);
      });
    });
  }, 1000);
});

$(document).ready(function() {
  $('.zoom-media').zoom();
});
